import type { FaireProductEntity } from "../../entity_types/product";

export const p_5dhthu8eyp: FaireProductEntity = {
  token: "p_5dhthu8eyp",
  type: "product",
  name: "ANDEE - Thong Heel, Back Heel Counter ✈️SHIPS TODAY",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/b62181525f98f6f0bc758aa6e29254b9b217c46df807a2d32e0fa545bf676b11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1420ca904340f2c1450d762eec71dcd33f1a3e10a19451e5a328e1da6484dc4.jpeg",
    "https://cdn.faire.com/fastly/1e12e1aa03e21590132cc78ab63e7839528ad98c586419a08676e6504f0af3d7.jpeg",
    "https://cdn.faire.com/fastly/82eafe4ded5a85ad3e8b6301156469127012d0a2a83f3d5b451562026f86f213.jpeg",
    "https://cdn.faire.com/fastly/95e24a709fac52d8dc7d1bfc8f2312b86fd9801fea4225c0816447959febfb3d.jpeg",
    "https://cdn.faire.com/fastly/5d6b0a2e9fca56dc5e0601e29492c716393cf585b1d633f5b4ff2c4fcaccc54e.jpeg",
    "https://cdn.faire.com/fastly/204ab7e34bb8274fcf01f38588a8b3bc71709b4c2453c00a7db2d40606299f44.jpeg",
    "https://cdn.faire.com/fastly/b4c2f5316e285ed415aec1bf65eb4a45326b392c4daf3c0f6c938cc9b6073c1b.jpeg",
    "https://cdn.faire.com/fastly/29d1a8373e365f33092c8a397df1dfbbcfe5537f31206fa7347422265041d088.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 12.25,
  description:
    "A barely-there silhouette with a bold attitude. This strappy thong heel features a sleek stiletto, sculpted side cutouts, and a minimal wrap that hugs just right. Available in soft suede and high-shine finishes, it’s the kind of heel that instantly elevates—clean, sharp, and a little unexpected. Please note: slight color shift may occur depending on lighting.\n\nOOTD\nStyle with a silky midi skirt and fitted tank for an easy night-out look, or pair with tailored trousers and a cropped blazer for that effortless “off-duty but polished” vibe. Also hits with a mini dress and slick bun moment.",
  tags: [],
  msrpDollars: 24.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:13.531Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
